import { render, staticRenderFns } from "./IpForbidden.vue?vue&type=template&id=3df3be2d&scoped=true"
import script from "./IpForbidden.vue?vue&type=script&lang=js"
export * from "./IpForbidden.vue?vue&type=script&lang=js"
import style0 from "./IpForbidden.vue?vue&type=style&index=0&id=3df3be2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3be2d",
  null
  
)

export default component.exports